"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleStatus = void 0;
exports.getBubbleStatuses = getBubbleStatuses;
exports.getBubbleStatusFrom = getBubbleStatusFrom;
exports.getBubbleStatusFromAttempt = getBubbleStatusFromAttempt;
var BubbleStatus;
(function (BubbleStatus) {
    BubbleStatus["Scored"] = "Scored";
    BubbleStatus["NotScored"] = "Not yet scored";
    BubbleStatus["NotCompleted"] = "Not completed";
    BubbleStatus["NotAttempted"] = "Not attempted";
})(BubbleStatus || (exports.BubbleStatus = BubbleStatus = {}));
function getBubbleStatuses() {
    return [
        BubbleStatus.Scored,
        BubbleStatus.NotScored,
        BubbleStatus.NotCompleted,
        BubbleStatus.NotAttempted,
    ];
}
function getBubbleStatusFrom(value) {
    return getBubbleStatuses().find(function (type) { return type === value; });
}
function getBubbleStatusFromAttempt(attempt) {
    var noStudentSubmission = attempt === null || attempt === void 0 ? void 0 : attempt.assessment.noStudentSubmissionsFlow;
    var status = (attempt === null || attempt === void 0 ? void 0 : attempt.isSubmitted) || noStudentSubmission
        ? (attempt === null || attempt === void 0 ? void 0 : attempt.isScored)
            ? BubbleStatus.Scored
            : BubbleStatus.NotScored
        : (attempt === null || attempt === void 0 ? void 0 : attempt.isNotCompleted) && !noStudentSubmission
            ? BubbleStatus.NotCompleted
            : BubbleStatus.NotAttempted;
    if (noStudentSubmission && !(attempt === null || attempt === void 0 ? void 0 : attempt.isScoredNoStudentSubmission)) {
        status = BubbleStatus.NotScored;
    }
    ;
    return status;
}
